import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const ProductIntegration = lazy(() => lazyRetry(() => import('containers/ProductIntegration')))

const route = [
  {
    name: i18n.t('routes.productIntegration.index'),
    path: '/product-integration',
    main: ProductIntegration,
    permissions: ['ROLE_VISUALIZAR_INTEGRACAO_PRODUTO'],
    exact: true
  }
]

export default route
